<template>
  <div class="applicant-table">
    <entry-history-dialog ref="entryHistoryDialog"></entry-history-dialog>
    <applicant-duplicate-entries ref="applicantDuplicateEntries"></applicant-duplicate-entries>
    <el-table class="mb-x2" :data="applicants" stripe @header-click="headerClick" empty-text=" " style="width: 100%">
      <el-table-column label="アカウント" sort-by="screenName" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">
          <applicant-name :applicant="scope.row" snsType="instagram" screen="応募一覧（IG）"></applicant-name>
        </template>
      </el-table-column>
      <el-table-column
        label="応募日時/投稿内容"
        sort-by="publishDatetime"
        :render-header="renderHeader"
        min-width="21%"
      >
        <template slot-scope="scope">
          <div layout layout-align="space-between">
            <div class="message-date" layout="column">
              <div class="publishDatetime" layout layout-align="start-center">
                <span>{{ formatDatetime(scope.row.post.publishDatetime) }}</span>
              </div>
              <div class="message-body">{{ scope.row.post.message }}</div>
            </div>
            <div class="post-image" v-if="scope.row.post.mediaUrl">
              <el-tooltip popper-class="image-zoom-tootip" :enterable="false" placement="right">
                <div slot="content"><img :src="scope.row.post.mediaUrl" /></div>
                <img :src="scope.row.post.mediaUrl" />
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="応募数" sort-by="-postCount" :render-header="renderHeader" min-width="9%">
        <template slot-scope="scope"
          ><span
            class="clickable"
            @click="openApplicantDuplicateEntries(scope.row.screenName, scope.row.duplicateEntries)"
            >{{ formatNumber(scope.row.postsCount) }}</span
          ></template
        >
      </el-table-column>
      <el-table-column
        label="累計参加数"
        sort-by="-totalCampaignEntryCount"
        :render-header="renderHeader"
        min-width="13%"
      >
        <template slot-scope="scope"
          ><span
            class="clickable"
            v-if="campaignAccountId"
            @click="
              openEntryHistoryDialog(
                scope.row.screenName,
                campaignAccountId,
                scope.row.accountId,
                0,
                campaignId,
                campaignStartDatetime
              )
            "
            >{{ formatNumber(scope.row.totalCampaignEntryCount) }}</span
          ><span v-else>{{ formatNumber(scope.row.totalCampaignEntryCount) }}</span></template
        >
      </el-table-column>
      <el-table-column
        label="累計当選数"
        sort-by="-totalCampaignWinningCount"
        :render-header="renderHeader"
        min-width="13%"
      >
        <template slot-scope="scope"
          ><span
            class="clickable"
            v-if="campaignAccountId"
            @click="
              openEntryHistoryDialog(
                scope.row.screenName,
                campaignAccountId,
                scope.row.accountId,
                1,
                campaignId,
                campaignStartDatetime
              )
            "
            >{{ formatNumber(scope.row.totalCampaignWinningCount) }}</span
          ><span v-else>{{ formatNumber(scope.row.totalCampaignWinningCount) }}</span></template
        >
      </el-table-column>
      <el-table-column min-width="20%">
        <template slot-scope="scope">
          <div class="action-button" layout>
            <!-- フォローフラグ-->
            <el-tooltip v-if="scope.row.isFollowing === 1" :enterable="false" placement="top" content="フォローを解除">
              <div>
                <el-button
                  class="is-follower-button el-button--icon"
                  type="primary"
                  @click="changeFlag(scope.row.id, 'is_follower', scope.row.isFollowing)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-account-network"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-else :enterable="false" placement="top" content="フォローに追加">
              <div>
                <el-button
                  class="is-follower-button el-button--icon"
                  type="default"
                  @click="changeFlag(scope.row.id, 'is_follower', scope.row.isFollowing)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-account-network"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- 候補者フラグ-->
            <el-tooltip
              v-if="scope.row.isNg === 1 && scope.row.isCandidate === 0"
              :enterable="false"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              v-else-if="scope.row.isCandidate === 1"
              placement="top"
              :enterable="false"
              content="候補者を解除"
            >
              <div>
                <el-button
                  class="is-candidate-button el-button--icon"
                  type="primary"
                  @click="changeFlag(scope.row.id, 'is_candidate', scope.row.isCandidate)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-else placement="top" :enterable="false" content="候補者に追加">
              <div>
                <el-button
                  class="is-candidate-button el-button--icon"
                  type="default"
                  @click="changeFlag(scope.row.id, 'is_candidate', scope.row.isCandidate)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-star"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- 当選者フラグ-->
            <el-tooltip
              v-if="scope.row.isNg === 1 && scope.row.isWinner === 0"
              :enterable="false"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-else-if="scope.row.isWinner === 1" :enterable="false" placement="top" content="当選者を解除">
              <div>
                <el-button
                  class="is-winner-button el-button--icon"
                  type="primary"
                  @click="changeFlag(scope.row.id, 'is_winner', scope.row.isWinner)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-else placement="top" :enterable="false" content="当選者に追加">
              <div>
                <el-button
                  class="is-winner-button el-button--icon"
                  type="default"
                  @click="changeFlag(scope.row.id, 'is_winner', scope.row.isWinner)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-trophy"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- 回答者フラグ-->
            <el-tooltip
              v-if="scope.row.isNg === 1 && scope.row.isResponder === 0"
              :enterable="false"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              v-else-if="scope.row.isResponder === 1"
              :enterable="false"
              placement="top"
              content="回答者を解除"
            >
              <div>
                <el-button
                  class="is-responder-button el-button--icon"
                  type="primary"
                  @click="changeFlag(scope.row.id, 'is_responder', scope.row.isResponder)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-else placement="top" :enterable="false" content="回答者に追加">
              <div>
                <el-button
                  class="is-responder-button el-button--icon"
                  type="default"
                  @click="changeFlag(scope.row.id, 'is_responder', scope.row.isResponder)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-clipboard-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- 当選連絡フラグ-->
            <el-tooltip
              v-if="scope.row.isNg === 1 && scope.row.isWinnerContact === 0"
              :enterable="false"
              placement="top"
              content="NGアカウント"
            >
              <div>
                <el-button class="el-button--icon" type="default" :disabled="true"
                  ><i class="mdi mdi-email-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip
              v-else-if="scope.row.isWinnerContact === 1"
              :enterable="false"
              placement="top"
              content="当選連絡を解除"
            >
              <div>
                <el-button
                  class="is-winner-contact-button el-button--icon"
                  type="primary"
                  @click="changeFlag(scope.row.id, 'is_winner_contact', scope.row.isWinnerContact)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-email-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-else placement="top" :enterable="false" content="当選連絡に追加">
              <div>
                <el-button
                  class="is-winner-contact-button el-button--icon"
                  type="default"
                  @click="changeFlag(scope.row.id, 'is_winner_contact', scope.row.isWinnerContact)"
                  :disabled="contractStatus === 3"
                  ><i class="mdi mdi-email-check"></i
                ></el-button>
              </div>
            </el-tooltip>
            <!-- Instagramで確認 -->
            <el-tooltip placement="top" :enterable="false" content="Instagramで確認">
              <a
                class="instagram-link"
                :href="scope.row.post.permalink"
                target="_new"
                @click="clickTwitterConfirmation"
              >
                <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button>
              </a>
            </el-tooltip>
            <!-- メッセージを送る -->
            <el-tooltip placement="top" :enterable="false" content="メッセージを送る">
              <a
                class="instagram-link"
                :href="'https://ig.me/m/' + scope.row.screenName"
                target="_new"
                @click="clickInstagramMessage"
              >
                <el-button class="el-button--icon" type="default"><i class="mdi mdi-send"></i></el-button>
              </a>
            </el-tooltip>
            <!-- NG追加/解除ボタン -->
            <a class="instagram-link" @click="changeNg(scope.row)">
              <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent(scope.row)">
                <div>
                  <el-button
                    class="is-primary-button el-button--icon"
                    :type="scope.row.isNg === 1 ? 'primary' : 'default'"
                    ><i class="mdi mdi-cancel"></i
                  ></el-button>
                </div>
              </el-tooltip>
            </a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        type="応募一覧（IG）"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-date {
  width: 100%;
  font-size: $font-small-size;
  line-height: 18px;

  .publishDatetime {
    color: $sub-text-color;
  }

  .message-body {
    max-height: 18px * 2;
    overflow-y: auto;
    white-space: pre-wrap;
  }

  .icon {
    width: 12px;
    height: 12px;
    margin-right: $spacing-unit;
  }
}

.post-image {
  margin-left: $spacing-unit;

  img {
    max-width: $spacing-unit * 10;
    max-height: $spacing-unit * 7;
  }
}

.last-processe-datetime {
  color: $sub-text-color;
  white-space: nowrap;
}

.badge {
  right: 12px;
  bottom: 18px;
}

.clickable {
  color: $info-color;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.is-follower-button:focus,
.is-candidate-button:focus,
.is-winner-button:focus,
.is-responder-button:focus,
.is-winner-contact-button:focus {
  color: $text-color;
  background: #fff;
  border: 1px solid $border-color;
}

.is-follower-button.el-button--primary:focus,
.is-candidate-button.el-button--primary:focus,
.is-winner-button.el-button--primary:focus,
.is-responder-button.el-button--primary:focus,
.is-winner-contact-button.el-button--primary:focus {
  color: #fff;
  background-color: $primary-color;
  border-color: $primary-color;
}

.sub-value {
  font-size: $font-small-size;
  color: $sub-text-color;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.action-button {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-unit;

  .el-button {
    height: 40px;
  }

  .mdi {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }

  .instagram-link {
    margin-top: 6px;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import Icon from '@/client/components/_atoms/basic_icon'
import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import ApplicantDuplicateEntries from '@/client/features/instagram_applicant/applicant_duplicate_entries'
import EntryHistoryDialog from '@/client/features/instagram_applicant/entry_history_dialog'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useInstagramApplicantStore } from '@/client/store/useInstagramApplicantStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { TApplicant } from '@/typings/api/instagram_applicants.type'

export default defineComponent({
  props: {
    applicants: Array,
    options: Object,
    campaignAccountId: {
      type: String,
      default: ''
    },
    campaignId: Number,
    campaignStartDatetime: String
  },
  components: {
    Pagination,
    ApplicantName,
    Icon,
    EntryHistoryDialog,
    ApplicantDuplicateEntries
  },
  data() {
    return {
      isSubmit: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      contractStatus: state => state.currentGroup.contractStatus
    })
  },
  methods: {
    formatDatetime,
    formatNumber,

    ...mapActions(useInstagramApplicantStore, ['fetchApplicants']),

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case 'アカウント':
          TrackingService.sendEvent('sort:応募一覧（IG）|アカウント')
          break
        case '応募日時/投稿内容':
          TrackingService.sendEvent('sort:応募一覧（IG）|応募日時/投稿内容')
          break
        case 'フォロワー':
          TrackingService.sendEvent('sort:応募一覧（IG）|フォロワー')
          break
        case '応募数':
          TrackingService.sendEvent('sort:応募一覧（IG）|応募数')
          break
        case '累計参加数':
          TrackingService.sendEvent('sort:応募一覧（IG）|累計参加数')
          break
        case '累計当選数':
          TrackingService.sendEvent('sort:応募一覧（IG）|累計当選数')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }

      if (column.sortBy.indexOf('-') === 0 && this.options.sortBy === column.sortBy) {
        this.$emit('sorting', column.sortBy.substring(1))
        this.fetchApplicants()
        return
      }

      if (column.sortBy.indexOf('-') !== 0 && this.options.sortBy === column.sortBy) {
        this.$emit('sorting', `-${column.sortBy}`)
        this.fetchApplicants()
        return
      }

      this.$emit('sorting', column.sortBy)
      this.fetchApplicants()
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    },

    /**
     * 対象応募者のフラグの変更
     */
    changeFlag(applicantId: number, type: string, value: number) {
      switch (type) {
        case 'is_follower':
          TrackingService.sendEvent('click:応募一覧（IG）|フォローに追加')
          break
        case 'is_candidate':
          TrackingService.sendEvent('click:応募一覧（IG）|候補者に追加')
          break
        case 'is_winner':
          TrackingService.sendEvent('click:応募一覧（IG）|当選者に追加')
          break
        case 'is_responder':
          TrackingService.sendEvent('click:応募一覧（IG）|回答者に追加')
          break
        case 'is_winner_contact':
          TrackingService.sendEvent('click:応募一覧（IG）|当選連絡に追加')
          break
        default:
          break
      }

      value = value === 1 ? 0 : 1
      const payload = { applicantId, type, value }

      this.$emit('change_flag', payload)
    },

    /**
     * ページング変更イベント
     */
    onChangePagingNo(page: number) {
      this.$emit('paging', { pagingNo: page })

      this.fetchApplicants()
    },

    /**
     * 表示件数変更イベント
     */
    onChangeLimitCount(limit: number) {
      this.$emit('paging', { limitCount: limit })

      this.fetchApplicants()
    },

    openApplicantDuplicateEntries(screenName: string, duplicateEntries: any) {
      TrackingService.sendEvent('click:応募一覧（IG）|応募数')

      this.$refs.applicantDuplicateEntries.open(screenName, duplicateEntries)
    },

    openEntryHistoryDialog(
      screenName: string,
      campaignAccountId: number,
      accountId: number,
      number: number,
      campaignId: number,
      campaignStartDatetime: string
    ) {
      TrackingService.sendEvent(`click:応募一覧（IG）|${number === 0 ? '累計参加数' : '累計当選数'}`)

      this.$refs.entryHistoryDialog.open(
        screenName,
        campaignAccountId,
        accountId,
        number,
        campaignId,
        campaignStartDatetime
      )
    },

    clickTwitterConfirmation() {
      TrackingService.sendEvent('click:応募一覧（IG）|Instagramで確認')
    },

    clickInstagramMessage() {
      TrackingService.sendEvent('click:応募一覧（IG）|メッセージを送る')
    },

    /**
     * NGアカウントのツールチップコンテンツ
     */
    ngTooltipContent(row: TApplicant) {
      return row.isNg === 1 ? 'NGアカウントを解除' : 'NGアカウントに追加'
    },

    /**
     * NGアカウント追加/解除
     */
    changeNg(row: TApplicant) {
      TrackingService.sendEvent('click:応募一覧（Instagram）|NGアカウントに追加')
      this.$emit('change_ng', {
        screenName: row.screenName,
        isNg: row.isNg === 0,
        ngApplicantId: row.ngApplicantId ?? null
      })
    }
  }
})
</script>
